(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryDeleteController',ProviderCategoryDeleteController);

    ProviderCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProviderCategory'];

    function ProviderCategoryDeleteController($uibModalInstance, entity, ProviderCategory) {
        var vm = this;

        vm.providerCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProviderCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
